import { useEffect, useRef, useState } from "react";
import studentApi from "../../api/studentApi";
import { useDebounce } from "../../hooks/useDebounce";

interface ListStudentPopupProps {
    onClose: () => void;
    onCancel: () => void;
    openPopup: boolean;
    courseCode: string;
    onData: (data: any[]) => void
}

export default function ListStudentPopup(props: ListStudentPopupProps) {
    const { openPopup, onClose, onCancel, courseCode, onData } = props;
    const [showList, setShowList] = useState(openPopup);
    const [keySearch, setKeySearch] = useState("");
    const [page, setPage] = useState(1);
    const [checkedAll, setCheckedAll] = useState(false);
    const [checkedIds, setCheckedIds] = useState<number[]>([]);
    // const [limit, setLimit] = useState(10);
    const keyword = useDebounce(keySearch, 500);
    const [listStudent, setListStudent] = useState<any[]>([]);
    const listRef = useRef<HTMLDivElement | null>(null);
    const handleScroll = () => {
        if (!listRef.current) return;

        const { scrollTop, scrollHeight, clientHeight } = listRef.current;

        // chạm đáy
        if (scrollTop + clientHeight >= scrollHeight - 10) {
            setPage((prev) => prev + 1);
        }
    };
    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            setShowList(false);
            setTimeout(onClose, 300);
        }
    };

    const handleSubmit = async () => {
        setShowList(false);
        setTimeout(onClose, 300);

        const selectedStudents = listStudent.filter(student => checkedIds.includes(student.id));
        console.log("selectedStudents", selectedStudents);
        onData(selectedStudents); // gửi danh sách đã chọn
    };

    useEffect(() => {
        setShowList(openPopup);
    }, [openPopup]);

    const getStudentData = async (courseCode: string, keyword: string, page: number) => {
        const params = {
            courseCode,
            keyword,
            page
        }
        const cleanedParams = Object.entries(params).reduce((acc, [key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                acc[key] = value;
            }
            return acc;
        }, {} as Record<string, any>);
        console.log("cleanedParams", cleanedParams)
        const res = await studentApi.searchStudent(cleanedParams);
        return res.data.items;
    }

    // Khi search thì reset page về 1
    useEffect(() => {
        setPage(1);
    }, [keyword]);

    useEffect(() => {
        if (!courseCode) return;

        const fetchData = async () => {
            const res = await getStudentData(courseCode, keyword, page);

            setListStudent(prev =>
                page === 1 ? res : [...prev, ...res]
            );
        };

        fetchData();
    }, [page, keyword,courseCode]);     // ← BẮT BUỘC PHẢI CÓ keyword



    const handleCheckAll = () => {
        if (checkedAll) {
            setCheckedIds([]);
        } else {
            setCheckedIds(listStudent.map((s: any) => s.id));
        }
        setCheckedAll(!checkedAll);
    };

    const handleCheckOne = (id: number) => {
        if (checkedIds.includes(id)) {
            setCheckedIds(checkedIds.filter((i) => i !== id));
        } else {
            setCheckedIds([...checkedIds, id]);
        }
    };


    return (
        <div
            className="fixed top-0 right-0 bottom-0 left-0 bg-[rgba(0,0,0,0.5)] z-[90] flex justify-center items-center transition-opacity duration-300"
            onClick={handleOverlayClick}
            style={{ opacity: showList ? 1 : 0 }}
        >
            <div
                className={`relative w-full lg:w-[800px] lg:min-h-[600px] h-[98%] bg-white p-[10px] rounded-box flex items-center flex-col transform transition-all duration-300 ${showList ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"
                    }`}
            >
                <h2 className="text-secondary font-bold text-[20px] my-[20px]">
                    Danh sách học sinh
                </h2>
                <div className="flex-1 flex flex-col my-[20px] w-[90%]">
                    <div className="relative mb-[20px] border border-[#e0e0e0] w-full h-[40px] flex rounded-[4px]">
                        <input className="outline-none rounded-[4px] pl-[16px] pr-[40px] inline-block w-full" placeholder="Nhập tên hoặc email học sinh để tìm" value={keySearch} onChange={e => setKeySearch(e.target.value)} />
                        {/* <i onClick={handleSearch} className="cursor-pointer fa fa-search absolute right-[10px] top-1/2 -translate-y-1/2"></i> */}
                    </div>
                    <div className="border border-[#e0e0e0] flex-1 rounded-[4px] px-[10px] pt-[10px]">
                        <div className="flex divide-x-[2px] divide-gray-300 justify-between border-b-[2px] border-gray-200 pb-[4px]">
                            <div className="flex justify-center items-center w-1/12">
                                <input className="w-4 h-4 text-center" type="checkbox" name="student" onChange={handleCheckAll} checked={checkedAll} />
                            </div>
                            <span className="w-1/12 text-center font-bold">ID</span>
                            <span className="w-5/12 text-center font-bold">Email</span>
                            <span className="w-5/12 text-center font-bold">Tên học sinh</span>
                        </div>
                        <div onScroll={handleScroll} ref={listRef}
                            className={`${listStudent?.length > 9 ? "custom-scroll overflow-y-scroll" : ""} max-h-[320px]`}>
                            {listStudent?.length > 0 && listStudent.map((student: any) => (
                                <div className="flex mt-[10px]">
                                    <div className="flex justify-center items-center w-1/12">
                                        <input className="w-4 h-4 text-center" type="checkbox" value={student.id} name="student" checked={checkedIds.includes(student.id)} onChange={() => handleCheckOne(student.id)} />
                                    </div>
                                    <span className="w-1/12 text-center">{student.studentId}</span>
                                    <span className="w-5/12 text-left pl-[10px]">{student.email}</span>
                                    <span className="w-5/12 text-left pl-[10px]">{student.fullName}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="">
                    <button
                        onClick={handleSubmit}
                        className="bg-secondary opacity-100 text-white py-[10px] px-[20px] rounded-[6px] hover:opacity-90 transition min-w-[100px] hover:scale-105"
                    >
                        Thêm
                    </button>
                    <button
                        onClick={onCancel}
                        className="border border-[#e0e0e0] ml-[20px] bg-white opacity-90 hover:opacity-100 text-[f8f9fa] px-[15px] py-[8px] rounded-[5px] min-w-[100px] hover:scale-105"
                    >
                        Hủy
                    </button>
                </div>
                <button
                    className="absolute top-[10px] right-[10px]"
                    onClick={() => setShowList(false)}
                >
                    <i className="fa-solid fa-close text-[22px] text-blue-500"></i>
                </button>
            </div>

        </div>
    )
}